import React, { useState, useEffect, useContext } from "react"
import styled, { createGlobalStyle } from "styled-components"
import * as lookup from "../../../static/lookup.json"
import Select from "react-select"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import { JourneyContext } from "../context/journeyContext"
import { getValueFromLookup, productRenderChecker, getValueFromJourney, getAge, generateConditonStateString } from "../services/helperFunctions"
import { ifscCodeDetails } from "../../services/apiservice"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { applyComma, lineCapital } from "../../shared/functions"
import Parser from 'html-react-parser';

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }

    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }
    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;        
        padding-right: 4px !important;        
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)
    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`
// const customStyles = {
//   option: (provided) => ({
//     ...provided,
//     // padding: 0,
//     zIndex:9999
//   }),
//   control: () => ({
//     // display:'flex'
//     // none of react-select's styles are passed to <Control />
//   }),
//   input:()=>({

//   }),
//   singleValue: (provided, state) => {
//     // const opacity = state.isDisabled ? 0.5 : 1;
//     // const transition = 'opacity 300ms';

//     // return { ...provided, opacity, transition };
//   }
// }

export default function ComponentTextSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [showLocalError, setShowLocalError] = useState(true)
  const ProductJourneyId = [
    "FlexiEdgeJourney",
    "titaniumPlusJourney",
    "alphaWealthPlanJourney",
    "guaranteedSavingsOption",
    "guaranteedIncomeAdvantage",
    "GuarateedOnePayJourney",
    "insureSmart",
    "moneyBackAdvantage",
    "jeevanNivesh",
    "invest4GJourney",
    "smartJuniorPlan",
    "secureBhavishyaJourney",
    "guaranteedFortuneJourney",
    "guaranteedFutureJourney",
    "guaranteedIncome4LifeJourney",
    "GAINjourney",
    "Promise4GrowthPlusJourney",
    "promise4WealthJourney"
  ]

  const validate = (target) => {
    if (props.data.required) { // required field validation
      if (props.data.not_rq_conds && props.data.not_rq_conds.length > 0) {
        if (props.data.not_rq_conds.length === 1 &&
          !componentRenderCheck(props.data.not_rq_conds[0], conditionState[props.data.not_rq_conds[0].watchKey], journeyState)) {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.data.requiredError
                ? (getValueFromJourney(
                  journeyState.lookup.required_error,
                  props.data.requiredError
                )) : `Error Code Not Found in Strapi`,
            })
          })
        }
        else if (props.data.not_rq_conds.length > 1 && !multiConditionComponentRenderCheck(props.data.not_rq_conds, conditionState, journeyState)) {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: props.data.requiredError
                ? (getValueFromJourney(
                  journeyState.lookup.required_error,
                  props.data.requiredError
                )) : `Error Code Not Found in Strapi`,
            })
          })
        }
        else {
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: ""
            })
          })
        }
      }
      else if (sectionState.sectionData && ((sectionState.sectionData[props.data.formControlKey] === "") || (!sectionState.sectionData[props.data.formControlKey]))) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
              ? (getValueFromJourney(
                journeyState.lookup.required_error,
                props.data.requiredError
              )) : `Error Code Not Found in Strapi`,
          })
        })
      } else {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: ""
          })
        })
      }
    }
    return
  }
  const pincodeGenricValidation = () => {
    let journeyIds = [
      "GuarateedOnePayJourney",
      "insureSmart",
      "jeevanNivesh",
      "FlexiEdgeJourney",
      "guaranteedIncomeAdvantage",
      "guaranteedSavingsOption",
      "titaniumPlusJourney",
      "alphaWealthPlanJourney",
      "moneyBackAdvantage",
      "invest4GJourney",
      "guaranteedFortuneJourney",
      "guaranteedFutureJourney",
      "IGFPPlusJourney",
      "guaranteedIncome4LifeJourney",
      "GAINjourney",
      "Promise4GrowthPlusJourney",
      "promise4WealthJourney"
    ]
    //sectionId in which have to add pincode validation logic
    let sectionIds = [
      "sectionGOPAJointLifeQuestionnaire",
      "SectionFlexiEdgeFillproposalOccupationDetails",
      "SectionFlexiEdgeFillProposalProposerDetails",
      "SectionFlexiEdgeResidenceandOccupationDetails",
      "SectionCommonResidenceAndOccupation",
      "proposerCommonResidenceAndOccupation"
    ]
    // country and phone country formcontrolkeys
    let PhoneCountrycodeKeys = [
      "mobileNumber",
      "GOPAcountry",
      'country',
      "jointlifeCommunicationCountry",
      "jointlifePermanentAddressCountry",
      "mobileSelectNumber",
      "proposerCommunicationCountry",
      "countryofbirth",
      "currentCountryofResidence",
      "eaCountry",
      "ProposerCountry",
      "empcountry",
      "proposerCountry",
      "GOPAproposerCode"
      

    ]
    if (journeyState.journeySteps && journeyIds.includes(journeyState.journeyIdFromStrapi) && sectionIds.includes(props?.sectionId) && PhoneCountrycodeKeys.includes(props.data.formControlKey)) {
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange
      let tempSectionIndexToChange
      let tempComponentGroupIndexToChange
      let compId = "GOPApincode"
      let formControlKeyForPincode = "GOPApincode"
      let compForState = "GOPAstate"
      let formControlKeyForState = "GOPAstate"
      let formControlKeyforcountry = "GOPAcountry"
      if (props?.sectionId === "sectionGOPAJointLifeQuestionnaire") {
        if (props.data.formControlKey === "jointlifePermanentAddressCountry") {
          compId = "jointlifePermanentAddressCountry_stateOrder-19"
          formControlKeyForPincode = "jointlifePermanentAddressPincode"
          compForState = "jointlifePermanentAddressCountry_stateOrder-19"
          formControlKeyForState = "jointlifePermanentAddressState"
          formControlKeyforcountry = "jointlifePermanentAddressCountry"
        } else if (props.data.formControlKey === "eaCountry") {
          compId = "JointLifeEAAddressLine1-order-61"
          formControlKeyForPincode = "eaPincode"
          compForState = "JointLifeEAAddressLine1-order-61"
          formControlKeyForState = "eaState"
          formControlKeyforcountry = "eaCountry"
        } else {
          compId = "jointlifeCommunicationPincodeOrder-12"
          formControlKeyForPincode = "jointlifeCommunicationPincode"
          compForState = "jointlifeCommunicationStateOrder-13"
          formControlKeyForState = "jointlifeCommunicationState"
          formControlKeyforcountry = "jointlifeCommunicationCountry"
        }
      }
      else if (props?.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails") {
        compId = "ODEmployerDetails"
        formControlKeyForPincode = "pincode"
        compForState = "ODEmployerDetails"
        formControlKeyForState = "state"
        formControlKeyforcountry = "country"
      }
      else if (props?.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "proposerCommunicationCountry") {
        compId = "communicationaddress"
        formControlKeyForPincode = "pincode"
        compForState = "communicationaddress"
        formControlKeyForState = "state"
        formControlKeyforcountry = "proposerCommunicationCountry"
      }
      else if (props?.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "ProposerCountry") {
        compId = "communicationAddressCondition"
        formControlKeyForPincode = "proposerPincode"
        compForState = "communicationAddressCondition"
        formControlKeyForState = "proposerState"
        formControlKeyforcountry = "ProposerCountry"
      }
      else if (props?.sectionId === "SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "empcountry") {
        compId = "employerdetails"
        formControlKeyForPincode = "emppincode"
        compForState = "employerdetails"
        formControlKeyForState = "empstate"
        formControlKeyforcountry = "empcountry"
      }

      else if (props?.sectionId === "SectionFlexiEdgeResidenceandOccupationDetails") {
        compId = "personalDetailsPincode"
        formControlKeyForPincode = "pincode"
        compForState = "flexistate"
        formControlKeyForState = "state"
        formControlKeyforcountry = "countryofbirth"
      }
      else if(props?.sectionId === "proposerCommonResidenceAndOccupation") {
        compId = "proposerPincode"
        formControlKeyForPincode = "proposerPincode"
        compForState = "proposerState"
        formControlKeyForState = "proposerState"
        formControlKeyforcountry = "proposerCountry"
      }

      tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === compId)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === formControlKeyForPincode)

      // TO FREEZE 
      let tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === compForState);
      let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === formControlKeyForState)
      console.log("qwerty", tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange);
      if (sectionState.sectionData[formControlKeyforcountry] && sectionState.sectionData[formControlKeyforcountry] !== "IN") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKeyForState]: "NR",
              // [formControlKeyForPincode]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regexError"] = "E300"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0017"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } else if (sectionState.sectionData[formControlKeyforcountry] === "IN" && !sectionState.sectionData[formControlKeyForState]) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0002"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKeyForPincode]: "",
              [formControlKeyForState]: "",
            }
          })
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } else if (sectionState.sectionData[formControlKeyforcountry] === "IN" && sectionState.sectionData[formControlKeyForState] === "NR") {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0002"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regexError"] = null

        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [formControlKeyForPincode]: "",
              [formControlKeyForState]: "",
            }
          })
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    if (props.sectionId === "FlexiEdgeFillProposalAppointeeSection" && props.data.formControlKey === "appointeeCountry"){
      const appointeeCountry = sectionState.sectionData["appointeeCountry"]
      if (appointeeCountry && appointeeCountry !== "IN"){
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "appointeePincode")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0017"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regexError"] = "E300"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setSectionState(prev => {
          return {
            ...prev, 
            sectionData : {
              ...prev.sectionData,
              "appointeeState" : "NR"
            }
          }
        })
      }else{
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "appointeePincode")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0002"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0002"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regexError"] = null
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setSectionState(prev => {
          return {
            ...prev, 
            sectionData : {
              ...prev.sectionData,
              "appointeeState" : ""
            }
          }
        })
      }
    }

    if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress"){
      const permanentCountry = sectionState.sectionData["permanentCountry"]
      if (permanentCountry && permanentCountry !== "IN"){
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "isYourCurrentResentialSameCondition")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincodePermanent")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] = "N0017"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionData : {
              ...prev.sectionData,
              "permanentState" : "NR"
            }
          }
        })
      }else{
        let temp = journeyState?.journeySteps
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "isYourCurrentResentialSameCondition")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincodePermanent")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 6
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len_error"] =  "N0002"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0002"
        
        // for freezing state to outside india
        let tempComponentStateIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "permanentState")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentStateIndexToChange]["disabled"] = true 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionData : {
              ...prev.sectionData,
              // "permanentState" : ""
            }
          }
        })
      }
    }
  }

  useEffect(() => {
    if (props.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress" && sectionState?.sectionData?.['state'] === "NR") {
      let temp = journeyState?.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === props?.pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props?.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "pincode")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_len_error"] = "M0018"
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
  }, [sectionState?.sectionData?.['state']])



  useEffect(() => {
    validate({ value: sectionState.sectionData?.[props.data.formControlKey] ?? "" })
    console.log(props?.data?.formControlKey, ['1', '2', '3', 'D'].includes(sectionState.sectionData?.[props.data.formControlKey]), sectionState.sectionData?.[props.data.formControlKey],)
    if (props?.data?.formControlKey === "educationalQualification" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "CPPersonalDetailsSection") {
      if (/*sectionState.sectionData["contactCountryCode"] === "+91" &&*/ !(['1', '2', '3', 'D'].includes(sectionState.sectionData?.[props.data.formControlKey]))) {
        setErrorState(prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      }
      // else if (sectionState.sectionData["contactCountryCode"] !== "+91" && !(['1','2'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
      //   setErrorState( prev => {
      //     // errorToastr(journeyState.planOption)
      //     return ({
      //       ...prev,
      //       [props.data.formControlKey]: `This option is not available for this plan`
      //     })
      //   })
      //   return
      // }
    }
    // if(props.data.formControlKey === "contactCountryCode" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "CPPersonalDetailsSection"){
    //   if(sectionState.sectionData[props.data.formControlKey] === "+91" && sectionState.sectionData["educationalQualification"] === "D" && errorState["educationalQualification"] === "This option is not available for this plan"){
    //     setErrorState( prev => {
    //       // errorToastr(journeyState.planOption)
    //       return ({
    //         ...prev,
    //         ["educationalQualification"]: ""
    //       })
    //     })
    //     return
    //   }else if(sectionState.sectionData[props.data.formControlKey] !== "+91" && sectionState.sectionData["educationalQualification"] === "D"){
    //     setErrorState( prev => {
    //       // errorToastr(journeyState.planOption)
    //       return ({
    //         ...prev,
    //         ["educationalQualification"]: `This option is not available for this plan`
    //       })
    //     })
    //     return
    //   }
    // }
    if (props?.data?.formControlKey === "education" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "spouseQuestionnaire") {
      if (sectionState.sectionData["residentStatus"] === "N" && !(['1', '2', '3', 'D'].includes(sectionState.sectionData?.[props.data.formControlKey]))) {
        setErrorState(prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      } else if (sectionState.sectionData["residentStatus"] !== "N" && !(['1', '2'].includes(sectionState.sectionData?.[props.data.formControlKey]))) {
        setErrorState(prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            [props.data.formControlKey]: `This option is not available for this plan`
          })
        })
        return
      }
    }
    if (props.data.formControlKey === "residentStatus" && sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "spouseQuestionnaire") {
      if (sectionState.sectionData[props.data.formControlKey] === "N" && ['3', '4'].includes(sectionState.sectionData["education"]) && errorState["education"] === "This option is not available for this plan") {
        setErrorState(prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            ["education"]: ""
          })
        })
        return
      } else if (sectionState.sectionData[props.data.formControlKey] !== "N" && ['3', '4'].includes(sectionState.sectionData["education"])) {
        setErrorState(prev => {
          // errorToastr(journeyState.planOption)
          return ({
            ...prev,
            ["education"]: `This option is not available for this plan`
          })
        })
        return
      }
    }
    // if(props?.data?.formControlKey === "education" && sectionState.sectionData?.[props.data.formControlKey] && !(['1','2','D'].includes(sectionState.sectionData?.[props.data.formControlKey]))){
    //   setErrorState( prev => {
    //     // errorToastr(journeyState.planOption)
    //     return ({
    //       ...prev,
    //       [props.data.formControlKey]: `This option is not available for this plan`
    //     })
    //   })
    //   return
    // }
    if (props.journeyIdFromStrapi === "ISelect360Journey" && props.sectionId === "iSelect360CPResidentAndOccupationDetailSection"
      && props.data.formControlKey === "residentStatus" && (sectionState.sectionData["gstWaiverInd"] === "Y"
        && sectionState.sectionData["residentStatus"] !== "Y")) {
      setSectionState((prev) => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            "gstWaiverInd": "N"
          },
        })
      })
      props.saveApplicationAndCallBi("gstWaiverInd", "N");
    }
    if (sectionState.sectionData?.[props.data.formControlKey] && sectionState.sectionId === "iSelect360CPResidentAndOccupationDetailSection" && props?.data?.formControlKey === "residentStatus") {
      let educationalQualification = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.educationalQualification"]
      let annualIncome = conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.AnnualIncome"]
      if (["Y", "S", "F"].includes(sectionState.sectionData?.[props.data.formControlKey])) {
        if ((!["1", "2"].includes(educationalQualification)) || annualIncome < 1000000) {
          setErrorState(prev => {
            // errorToastr(journeyState.planOption)
            return ({
              ...prev,
              [props.data.formControlKey]: `This option is not available for this plan`
            })
          })
          return
        }
      }
    }
    if (props.data.formControlKey === "bankName" && sectionState.sectionData?.["bankName"] && sectionState.sectionId === "SectionFlexiEdgeBankDetailsOfProposer") {
      console.log(sectionState.sectionData?.["bankName"])
      let payload = {
        "MIR-BNK-IFSC-CD": sectionState.sectionData?.["ifscCode"]
      }
      ifscCodeDetails(payload)
        .then(res => {
          console.log(res.data)
          let bankAddressList = res?.data?.bankAddress?.[sectionState.sectionData?.["bankName"]]
          let bankAddress = []
          bankAddress.push(bankAddressList)
          let temp = journeyState.journeySteps
          let tempPageIndexToChange
          let tempSectionIndexToChange
          let tempComponentGroupIndexToChange
          let tempComponentIndexToChange
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeBankDetailsOfProposer")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "bankBranchName")
          tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "bankBranchName")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = bankAddress
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
          if (Object.keys(bankAddressList)?.length === 1) {
            let bank = Object.keys(bankAddressList)[0]
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  bankBranchName: bank
                }
              })
            })
          }
        })
        .catch((err) => {
          console.log("please enter valid ifsc code", err);
        })
    }
    if (props?.data?.formControlKey === "CPResidentAndOccupationType" && sectionState.sectionData?.[props.data.formControlKey] && !(['1', '3'].includes(sectionState.sectionData?.[props.data.formControlKey]))) {
      setErrorState(prev => {
        // errorToastr(journeyState.planOption)
        return ({
          ...prev,
          [props.data.formControlKey]: `This option is not available for this plan`
        })
      })
      return
    }
    if (props.data.formControlKey === "AppointeeFullNameTitle" && sectionState.sectionData["AppointeeFullNameTitle"]) {
      autoFill({ value: sectionState.sectionData["AppointeeFullNameTitle"] })
    }
    if (props.data.formControlKey === "fullNameTitle" && sectionState.sectionData && sectionState.sectionData["fullNameTitle"] && journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSNomineeDetails") {
      autoFill({ value: sectionState.sectionData["fullNameTitle"] })
    }
    // For Spouse Age proof dropdown change based on country code
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (props.sectionId == "spouseQuestionnaire" && props?.data?.formControlKey === "countryCode")) {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ageProof-order-15")
      let tempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "ageProof")
      let spouselookupKeyForAgeProof
      if (sectionState.sectionData["countryCode"] === "+91") {
        spouselookupKeyForAgeProof = "AGE_PROOF_IN"
      } else {
        spouselookupKeyForAgeProof = "AGE_PROOF_NON_IN"
      }
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeAgeProof]["lookupKey"] = spouselookupKeyForAgeProof
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
      setSectionState((prev) => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["ageProof"]: ""
          },
        })
      })
    }

    //For state autoFill in residential and occupationDetail
    if (props.data.formControlKey.toLowerCase().includes("country") && (props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection")) {
      autoFill({ value: sectionState.sectionData["country"] })
    }

    //For  if occupation is not salried and self employed then empty a employer detail
    // Move that logic to backend in forward mapper
    //  if(journeyState.journeyIdFromStrapi == "FlexiEdgeJourney" && (props.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails") && props.data.formControlKey == "occupation"){
    //   if(sectionState.sectionData?.["occupation"] !=1 && sectionState.sectionData?.["occupation"] !=3){
    //     setSectionState((prev) => {
    //       return ({
    //         ...prev,
    //         sectionData: {
    //           ...prev.sectionData,
    //           ["CPcompanyName"]: "",
    //           ["nameOfTheIndustry"]: "",
    //           ["addresslineone"]: "",
    //           ["addressLineTwo"]: "",
    //           ["addressLineThree"]: "",
    //           ["pincode"]: "",
    //           ["country"]: "",
    //           ["state"]: "",
    //           ["cityemp"]: ""
    //         },
    //       })
    //     })
    //   }
    //  }

  }, [sectionState.sectionData?.[props.data.formControlKey], props.reqCondWatchKeys?.length && conditionState[props.reqCondWatchKeys[0]],
  props.reqCondWatchKeys?.length == 2 && conditionState[props.reqCondWatchKeys[1]]
  ])

  useEffect(() => {
    let temp = journeyState.journeySteps
    let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
    let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFemaleMedicalQuestionaire")

    //For Husband
    let husbandTempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "husbandName")
    let husbandTempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[husbandTempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "husbandName")

    //For SpouseOccupation
    let occupationTempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "spouseOccupation")
    let occupationTempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[occupationTempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "spouseOccupation")

    // For SpouseInsuranceAmount
    let insuranceTempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "spouseInsuranceAmount")
    let insuranceTempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[insuranceTempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "spouseInsuranceAmount")

    // For AnnualIncome
    let incomeTempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "annualIncome")
    let incomeTempComponentIndexToChangeAgeProof = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[incomeTempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "femaleAnnualIncome")

    if (conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.martialStatus"] === "S") {
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[husbandTempComponentGroupIndexToChange].components[husbandTempComponentIndexToChangeAgeProof]["required"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[occupationTempComponentGroupIndexToChange].components[occupationTempComponentIndexToChangeAgeProof]["required"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[insuranceTempComponentGroupIndexToChange].components[insuranceTempComponentIndexToChangeAgeProof]["required"] = false
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[incomeTempComponentGroupIndexToChange].components[incomeTempComponentIndexToChangeAgeProof]["required"] = false
    } else {
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[husbandTempComponentGroupIndexToChange].components[husbandTempComponentIndexToChangeAgeProof]["required"] = true
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[occupationTempComponentGroupIndexToChange].components[occupationTempComponentIndexToChangeAgeProof]["required"] = true
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[insuranceTempComponentGroupIndexToChange].components[insuranceTempComponentIndexToChangeAgeProof]["required"] = true
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[incomeTempComponentGroupIndexToChange].components[incomeTempComponentIndexToChangeAgeProof]["required"] = true
    }

    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })
  }, [conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.martialStatus"]])

  useEffect(() => {
    console.log("before", errorState, sectionState.sectionData?.[props.data.formControlKey]);
    if (sectionState.sectionData?.["GOPAcpRelationshipwithLa"] === "OTHER" && props.sectionId === "SectionGOPAChooseYourPlan") {
      setErrorState(prev => {
        return ({
          ...prev,
          [["GOPAcpRelationshipwithLa"]]: "This option is not available for this plan"
        })
      })
      setShowLocalError(false)
      return
    }
    else {
      setErrorState(prev => {
        return ({
          ...prev,
          [["GOPAcpRelationshipwithLa"]]: ""
        })
      })
      setShowLocalError(true)
    }
    validate({ value: sectionState.sectionData?.[props.data.formControlKey] ?? "" })
  }, [sectionState.sectionData?.['GOPAcpRelationshipwithLa']])
  //To select value to india for as country code
  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.formControlKey]) {
      if (props.data.defaultValue) { // remove this condition && props.sectionId === "CPPersonalDetailsSection"  === "contactCountryCode"
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: props.data.defaultValue
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: props.data.defaultValue,
          }
        })
      }
      // else if(props.data.formControlKey === "AppointeeFullNameTitle"){
      //   setSectionState((prev) => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         [props.data.formControlKey]: "MR"
      //       },
      //     })
      //   })
      //   setConditionState(prev => {
      //     return {
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "MR",
      //     }
      //   })
      // }

      if (((conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] === "+91" ||
        conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] === "+91") && props.sectionId !== "CPPersonalDetailsSection") ||
        (conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.mobileNumber"] === "+91" && props.sectionId != "SectionFlexiEdgeResidenceandOccupationDetails") ||
        (conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation") ||
        (conditionState["PageHealthFirstCalculateFundValue.SectionHealthFirstPersonelDetails.mobileNumber"] === "+91" && props.sectionId != "SectionCommonResidenceAndOccupation")) {
        if (props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")) {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "+91"
              },
            })
          })
        }
        else if (props.data.formControlKey != "countryCode" && props.data.formControlKey != "MobAlternateCountryCode" && props.data.formControlKey != "proposerAlternateMobCountryCode" && props.data.formControlKey != "AlternateMobCountryCode" && props.data.formControlKey != "contactCountryCode" && props.data.formControlKey != "countryCodeNominee" && props.data.formControlKey !== "nomineeCountryCode" && props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality" || props.data.formControlKey === "nationality" || props.data.formControlKey === "citizenship") {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "IN",
            }
          })
        } else if (props.data.formControlKey === "residentStatus" || props.data.formControlKey === "residentialStatus") {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "N"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "N",
            }
          })
        }
      } else {
        if (props.sectionId === "personalDetailsSection" && (props.data.formControlKey === "AlternateMobCountryCode")) {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: props.journeyIdFromStrapi === "iSelectJourney" ? conditionState["calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"] : props.journeyIdFromStrapi === "ISelect360Journey" ? conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"] : "+91"
              },
            })
          })
        } else if ((props.data.formControlKey.toLowerCase().includes("country") || props.data.formControlKey === "residentialCitizenship" || props.data.formControlKey === "residentialNationality") && props.sectionId !== "CPPersonalDetailsSection" && props.sectionId !== "SectionGuaranteedSavingPersonaldetails" && props.sectionId !== "SectionPOSNomineeDetails") {
          let countryCodeConditionStateKey
          if (props.journeyIdFromStrapi === "iSelectJourney") {
            countryCodeConditionStateKey = "calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"
          } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
            countryCodeConditionStateKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"
          } else if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
            countryCodeConditionStateKey = "PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
            countryCodeConditionStateKey = "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
            countryCodeConditionStateKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "insureSmart") {
            countryCodeConditionStateKey = "PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
            countryCodeConditionStateKey = "PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
            countryCodeConditionStateKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
            countryCodeConditionStateKey = "PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "invest4GJourney") {
            countryCodeConditionStateKey = "PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
            countryCodeConditionStateKey = "PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
            countryCodeConditionStateKey = "AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection.mobileNumber"
          } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
            countryCodeConditionStateKey = "PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
            countryCodeConditionStateKey = "PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
            countryCodeConditionStateKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
            countryCodeConditionStateKey = "PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.mobileNumber"
          } else if (props.journeyIdFromStrapi === "GAINjourney") {
            countryCodeConditionStateKey = "GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"
          } else if (props.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
            countryCodeConditionStateKey = "Promise4GrowthPlusCalculateFundValuePage.Promise4GrowthPlusCFpersonelDetailsSection.mobileNumber"
          } else if (props.journeyIdFromStrapi === "promise4WealthJourney") {
            countryCodeConditionStateKey = "Pagepromise4WealthJourneyCalculatePremium.Promise4WealthCFpersonelDetailsSection.mobileNumber"
          }

          if (props.sectionId === "proposerCommonResidenceAndOccupation"  || props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails"){
            if (props.journeyIdFromStrapi === "iSelectJourney") {
              countryCodeConditionStateKey = "calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"
            } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
              countryCodeConditionStateKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"
            } else if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
              countryCodeConditionStateKey = "PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.proposerNumber"
            } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
              countryCodeConditionStateKey = "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
              countryCodeConditionStateKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "insureSmart") {
              countryCodeConditionStateKey = "PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
              countryCodeConditionStateKey = "PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
              countryCodeConditionStateKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
              countryCodeConditionStateKey = "PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "invest4GJourney") {
              countryCodeConditionStateKey = "PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
              countryCodeConditionStateKey = "PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.proposerNumber"
            } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
              countryCodeConditionStateKey = "AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection.proposerNumber"
            } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
              countryCodeConditionStateKey = "PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
              countryCodeConditionStateKey = "PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
              countryCodeConditionStateKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
              countryCodeConditionStateKey = "PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "GAINjourney") {
              countryCodeConditionStateKey = "GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAproposerCode"
            } else if (props.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
              countryCodeConditionStateKey = "Promise4GrowthPlusCalculateFundValuePage.Promise4GrowthPlusCFpersonelDetailsSection.proposerNumber"
            } else if (props.journeyIdFromStrapi === "promise4WealthJourney") {
              countryCodeConditionStateKey = "Pagepromise4WealthJourneyCalculatePremium.Promise4WealthCFpersonelDetailsSection.mobileNumber"
            }
            
          }

          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: getValueFromLookup("countryCodeToCountry", conditionState[countryCodeConditionStateKey]) || "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: getValueFromLookup("countryCodeToCountry", conditionState[countryCodeConditionStateKey]) || "IN"
            }
          })
          autoFill({})
        } else if (props.data.formControlKey === "residentStatus") {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: "Y"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: "Y",
            }
          })
        }
      }

      if (props.data.formControlKey.toLowerCase().includes("country") && (props.sectionId === "proposerCommonResidenceAndOccupation" || props.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")){
        let countryCodeConditionStateKey=''
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          countryCodeConditionStateKey = "calculatePremiumPage.CPPersonalDetailsSection.contactCountryCode"
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          countryCodeConditionStateKey = "PageISelect360CalculatePremium.CPPersonalDetailsSection.contactCountryCode"
        } else if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
          countryCodeConditionStateKey = "PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.proposerNumber"
        } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
          countryCodeConditionStateKey = "PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
          countryCodeConditionStateKey = "PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "insureSmart") {
          countryCodeConditionStateKey = "PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
          countryCodeConditionStateKey = "PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
          countryCodeConditionStateKey = "PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
          countryCodeConditionStateKey = "PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "invest4GJourney") {
          countryCodeConditionStateKey = "PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
          countryCodeConditionStateKey = "PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.proposerNumber"
        } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
          countryCodeConditionStateKey = "AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection.proposerNumber"
        } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
          countryCodeConditionStateKey = "PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
          countryCodeConditionStateKey = "PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
          countryCodeConditionStateKey = "PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
          countryCodeConditionStateKey = "PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "GAINjourney") {
          countryCodeConditionStateKey = "GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAproposerCode"
        } else if (props.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
          countryCodeConditionStateKey = "Promise4GrowthPlusCalculateFundValuePage.Promise4GrowthPlusJourneyCFpersonelDetailsSection.proposerNumber"
        } else if (props.journeyIdFromStrapi === "promise4WealthJourney") {
          countryCodeConditionStateKey = "Pagepromise4WealthJourneyCalculatePremium.Promise4WealthCFpersonelDetailsSection.mobileNumber"
        }
        if(props.data.formControlKey === "proposerAlternateMobCountryCode"){
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: conditionState[countryCodeConditionStateKey] || "+91"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: getValueFromLookup("countryCodeToCountry", conditionState[countryCodeConditionStateKey]) || "IN"
            }
          })
        } else {
          setSectionState((prev) => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [props.data.formControlKey]: getValueFromLookup("countryCodeToCountry", conditionState[countryCodeConditionStateKey]) || "IN"
              },
            })
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: getValueFromLookup("countryCodeToCountry", conditionState[countryCodeConditionStateKey]) || "IN"
            }
          })
        }
        autoFill({})

      }

    }
    if ((journeyState.journeyIdFromStrapi == "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi == "guaranteedIncome4LifeJourney") && (props.sectionId == "sectionGOPAJointLifeQuestionnaire") && sectionState.sectionData[props.data.formControlKey]) {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "sectionGOPAJointLifeQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "jointlifefullnameorder-2")
      let tempComponentIndexToChangeOccupation = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "JointLifeTitle")

      if (sectionState.sectionData.gender == "M") {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeOccupation]["disabled"] = true
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["JointLifeTitle"]: "MR",
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } if (sectionState.sectionData.gender == "F" || sectionState.sectionData.gender == "T") {

        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeOccupation]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeOccupation]["lookupKey"] = "title-female"
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }

    }
    // For Spouse Occupation Dropdown based on occupation selection of previous section
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (props.sectionId == "spouseQuestionnaire")) {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "occupation-order-9")
      let tempComponentIndexToChangeOccupation = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "occupation")

      let spouseOccupationType = conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"]
      let spouselookupKeyForOccupation
      if (spouseOccupationType && (spouseOccupationType === "NW")) {
        spouselookupKeyForOccupation = "occupation_SPOUSE_NONWORKING"
      } else {
        spouselookupKeyForOccupation = "occupation_SPOUSE_WORKING"
      }
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeOccupation]["lookupKey"] = spouselookupKeyForOccupation
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [props.sectionId])

  useEffect(() => {
    if(journeyState.planOptionList){ 
      if(journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney" && props.sectionId === "SectionGuaranteedIncome4LifeChooseYourPlan"){
          let planOption = []
          planOption.push(journeyState.planOptionList)
          let temp = journeyState.journeySteps;
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedIncome4LifeCalculatePremium")
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedIncome4LifeChooseYourPlan")
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GI4LPlanOption")
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GI4LPlanOption")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = planOption
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
      }
    }
}, [sectionState.sectionId])

useEffect(() => {
  if (sectionState.sectionData?.["GAINppt"] && journeyState.journeyIdFromStrapi === "GAINjourney" && sectionState.sectionData?.["gainPlanOption"] === "GA2TP1") {
    setSectionState(prev => {
      return {
        ...prev,
        sectionData: {
          ...prev.sectionData,
          ["GAINincomePayoutPeriod"] : `0${sectionState.sectionData["GAINppt"]}`
        }
      }
    })
  }
}, [sectionState.sectionData?.["GAINppt"]])

useEffect(() => {
  if (sectionState.sectionData?.["GAINincomePayoutPeriod"] && journeyState.journeyIdFromStrapi === "GAINjourney") {
    let ptValue
    let temp = journeyState.journeySteps;
    const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
    }
    if(sectionState.sectionData?.["gainPlanOption"] === "GA2TP3"){
      if(sectionState.sectionData["GAINincomePayoutPeriod"] === "29"){
        ptValue = "30"
      } else {
        ptValue = "40"
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["GAINpt"] : ptValue
          }
        }
      })
    } else {
      ptValue = Number(sectionState.sectionData["GAINincomePayoutPeriod"]) + Number(sectionState.sectionData["GAINppt"]) + Number(sectionState.sectionData["GAINdefermentPeriod"])
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["GAINpt"] : ptValue
          }
        }
      })
    }
    if(sectionState.sectionData?.["gainPlanOption"] === "GA2TP1" && sectionState.sectionData["GAINppt"]){
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "disabled", true)
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["GAINincomePayoutPeriod"] : `0${sectionState.sectionData["GAINppt"]}`
          }
        }
      })
    }
  }
}, [sectionState.sectionData?.["GAINincomePayoutPeriod"], sectionState.sectionData?.["GAINppt"], sectionState.sectionData?.["GAINdefermentPeriod"]])

useEffect(() => {
  if (sectionState.sectionData?.["gainPlanOption"] && journeyState.journeyIdFromStrapi === "GAINjourney") {
    let temp = journeyState.journeySteps;
    const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
    }
    if (sectionState.sectionData["gainPlanOption"] == "GA2TP3") {
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINdefermentPeriod", "GAINdefermentPeriod", "lookupKey", "GAINDefermentPeriodEarlyIncome")
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINppt", "GAINppt", "lookupKey", "GAINpttEI")
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "lookupKey", "GAINearlyIncome")
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "disabled", false)
      if(sectionState.sectionData["GAINdefermentPeriod"] && !Object.keys(lookup["GAINDefermentPeriodEarlyIncome"][0]).includes(sectionState.sectionData.GAINdefermentPeriod)){
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GAINdefermentPeriod"]: "00"
            }
          }
        })
      }
      if(sectionState.sectionData["GAINppt"] && !Object.keys(lookup["GAINpttEI"][0]).includes(sectionState.sectionData.GAINppt)){
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GAINppt"] : "10"
            }
          }
        })
      }
      if(sectionState.sectionData["GAINincomePayoutPeriod"] && !Object.keys(lookup["GAINearlyIncome"][0]).includes(sectionState.sectionData.GAINincomePayoutPeriod)){
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GAINincomePayoutPeriod"] : "29"
            }
          }
        })
      }
    } else{
      if (sectionState.sectionData["gainPlanOption"] == "GA2TP1") {
        changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINppt", "GAINppt", "lookupKey", "GAINpttST")
        changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "lookupKey", "GAINearlyIncomeST")
        if(sectionState.sectionData["GAINppt"] && !Object.keys(lookup["GAINpttST"][0]).includes(sectionState.sectionData.GAINppt)){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GAINppt"] : "5"
              }
            }
          })
        }
        if(sectionState.sectionData["GAINppt"]){
          changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "disabled", true)
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GAINincomePayoutPeriod"] : `0${sectionState.sectionData["GAINppt"]}`
              }
            }
          })
        }
      } else if (sectionState.sectionData["gainPlanOption"] == "GA2TP2") {
        changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINppt", "GAINppt", "lookupKey", "GAINpttLT")
        changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "lookupKey", "GAINLongTerm")
        changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINincomePayoutPeriod", "GAINincomePayoutPeriod", "disabled", false)
        if(sectionState.sectionData["GAINppt"] && !Object.keys(lookup["GAINpttLT"][0]).includes(sectionState.sectionData.GAINppt)){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GAINppt"] : "5"
              }
            }
          })
        }
        if(sectionState.sectionData["GAINincomePayoutPeriod"] && !Object.keys(lookup["GAINLongTerm"][0]).includes(sectionState.sectionData.GAINincomePayoutPeriod)){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GAINincomePayoutPeriod"] : "10"
              }
            }
          })
        }
      }
      changeJourneySteps("GAINcalculatePremiumPage", "GAINchooseYourPlan", "GAINdefermentPeriod", "GAINdefermentPeriod", "lookupKey", "GAINDefermentPeriod")
    }
    // JOURNEY STATE UPDATE
    setJourneyState(prev => ({
      ...prev,
      journeySteps: temp
    }))
  }

}, [sectionState.sectionData?.["gainPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    /**
     * Note : Premium payment term formControlKey is mis-spelled as GI4LPreiumPaymentTerm
     */
    if (sectionState.sectionData?.["GI4LPlanOption"] && journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
      let newLookupKeyForPPT = "policyTerm";
      let newLookupKeyForIP = "policyTerm";
      let newLookupKeyForPremiumFrequency = "GI4LPaymentFrequency"
      let newValueForIncomePeriod;

      switch (sectionState.sectionData?.["GI4LPlanOption"]) {
        case "GIFLP1":
          newLookupKeyForPPT = "GI4LPremiumPolicyTermGI"
          newLookupKeyForPremiumFrequency = "GI4LPaymentFrequencyNoSG"
          newLookupKeyForIP = "GI4LIncomePeriodGI"
          break;
        case "GIFLP2":
          newLookupKeyForPPT = "GI4LPremiumPolicyTermGLI"
          newLookupKeyForPremiumFrequency = "GI4LPaymentFrequencyNoSG"
          newLookupKeyForIP = "GI4LIncomePeriodGLI"
          break;
        case "GIFLP3":
          newLookupKeyForPPT = "GI4LPremiumPolicyTermGLLI"
          newValueForIncomePeriod = 99 - getAge(conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.GOPAdob"])
          break;
      }
      let temp = journeyState.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
      }

      changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LPaymentFrequency", "GI4LPaymentFrequency", "lookupKey", newLookupKeyForPremiumFrequency)
      changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LLifeOption", "GI4LLifeOption", "disabled", false)
      changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", false)

      if (sectionState.sectionData["GI4LPlanOption"] !== "GIFLP3") {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LLifeOption", "GI4LLifeOption", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LLifeOption"] = "1";
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
        // ConditionState update
        setConditionState(prev => ({
          ...prev,
          ["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifeChooseYourPlan.GI4LLifeOption"]: "1"
        }))
      }

      if (sectionState.sectionData["GI4LPreiumPaymentTerm"]) {
        let tempSection = sectionState.sectionData;
        let firstKey;
        for (var key in lookup[newLookupKeyForPPT][0]) {
          firstKey = key;
          break;
        }
        tempSection["GI4LPreiumPaymentTerm"] = firstKey;
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
      }

      changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LPreiumPaymentTerm", "GI4LPreiumPaymentTerm", "lookupKey", newLookupKeyForPPT)

      if (sectionState.sectionData["GI4LIncomePeriod"]) {
        let tempSection = sectionState.sectionData;
        let firstKey;
        for (var key in lookup[newLookupKeyForIP][0]) {
          firstKey = key;
          break;
        }
        tempSection["GI4LIncomePeriod"] = firstKey;
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
      }

      if (sectionState.sectionData?.["GI4LPlanOption"] === "GIFLP1" && sectionState.sectionData?.["GI4LPreiumPaymentTerm"]) {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LIncomePeriod"] = sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
        // ConditionState update
        setConditionState(prev => ({
          ...prev,
          ["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifeChooseYourPlan.GI4LIncomePeriod"]: sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        }))
      } else {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", false)
      }

      changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "lookupKey", newLookupKeyForIP)

      if (newValueForIncomePeriod) {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LIncomePeriod"] = newValueForIncomePeriod;
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
      }
      // JOURNEY STATE UPDATE
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }

  }, [sectionState.sectionData?.["GI4LPlanOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["GI4LPaymentFrequency"] && journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
      let sumAssuredValue = 0;
      if (sectionState.sectionData?.["GI4LPaymentFrequency"] === "SG") {
        // console.info("TEMP ----",sectionState.sectionData?.["GI4LLifeOption"])
        if (sectionState.sectionData?.["GI4LLifeOption"] === "1") {
          sumAssuredValue = sectionState.sectionData?.["GI4LPremiumAmount"] * 1.25
        } else if (sectionState.sectionData?.["GI4LLifeOption"] === "2") {
          sumAssuredValue = sectionState.sectionData?.["GI4LPremiumAmount"] * 10
        }
      } else {
        sumAssuredValue = sectionState.sectionData?.["GI4LPremiumAmount"] * (12 / sectionState.sectionData?.["GI4LPaymentFrequency"]) * 11
      }
      let temp = journeyState.journeySteps;

      if (sumAssuredValue) {
        let tempSection = sectionState.sectionData;
        tempSection["GI4LSumAssured"] = applyComma(Math.round(sumAssuredValue));
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
      }
      // JOURNEY STATE UPDATE
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [sectionState.sectionData?.["GI4LPaymentFrequency"], sectionState.sectionData?.["GI4LLifeOption"], props.nvestFilterResult])

  useEffect(() => {
    if (sectionState.sectionData?.["GI4LPreiumPaymentTerm"] && journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
      let temp = journeyState.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
      }


      console.log("GI4L__", sectionState.sectionData?.["GI4LPlanOption"] === "GIFLP1", sectionState.sectionData?.["GI4LPreiumPaymentTerm"])
      if (sectionState.sectionData?.["GI4LPlanOption"] === "GIFLP1" && sectionState.sectionData?.["GI4LPreiumPaymentTerm"]) {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LIncomePeriod"] = sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
        // ConditionState update
        setConditionState(prev => ({
          ...prev,
          ["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifeChooseYourPlan.GI4LIncomePeriod"]: sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        }))
      } else {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", false)
      }

      // JOURNEY STATE UPDATE
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [sectionState.sectionData?.["GI4LPreiumPaymentTerm"]])

  useEffect(() => {
    if (sectionState.sectionData?.["GI4LPreiumPaymentTerm"] && sectionState.sectionData?.["GI4LDefermentPeriod"] && journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
      let policyTermValue = +sectionState.sectionData?.["GI4LPreiumPaymentTerm"] + +sectionState.sectionData?.["GI4LDefermentPeriod"];
      let temp = journeyState.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
      }

      if (policyTermValue) {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LPolicyTerm", "GI4LPolicyTerm", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LPolicyTerm"] = policyTermValue;
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
      }

      console.log("GI4L__", sectionState.sectionData?.["GI4LPlanOption"] === "GIFLP1", sectionState.sectionData?.["GI4LPreiumPaymentTerm"])
      if (sectionState.sectionData?.["GI4LPlanOption"] === "GIFLP1" && sectionState.sectionData?.["GI4LPreiumPaymentTerm"]) {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", true)
        let tempSection = sectionState.sectionData;
        tempSection["GI4LIncomePeriod"] = sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        setSectionState(prev => ({
          ...prev,
          sectionData: tempSection
        }))
        // ConditionState update
        setConditionState(prev => ({
          ...prev,
          ["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifeChooseYourPlan.GI4LIncomePeriod"]: sectionState.sectionData?.["GI4LPreiumPaymentTerm"]
        }))
      } else {
        changeJourneySteps("PageGuaranteedIncome4LifeCalculatePremium", "SectionGuaranteedIncome4LifeChooseYourPlan", "GI4LIncomePeriod", "GI4LIncomePeriod", "disabled", false)
      }

      // JOURNEY STATE UPDATE
      setJourneyState(prev => ({
        ...prev,
        journeySteps: temp
      }))
    }
  }, [sectionState.sectionData?.["GI4LPreiumPaymentTerm"], sectionState.sectionData?.["GI4LDefermentPeriod"]])

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: target.value,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(conditionState, "dhdhdj")
    validate(target)
    if (props.saveApplicationAndCallBi) {
      props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
    }

     if (props.data.formControlKey === "mobileNumber"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "contactNo" : "",
            "numberMask" : ""
          }
        }
      })
    }
    if (props.data.formControlKey === "GOPAproposerCode" || props.data.formControlKey === "proposerNumber"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "GOPAnumber" : "",
            "contactNoproposerMask" : "",
            "contactNoproposer" : ""
          }
        }
      })
    }
    if (props.data.formControlKey === "MobAlternateCountryCode"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "AlternateMobNumber" : "",
            "AlternateMobNumbermask" : ""
          }
        }
      })
    }
    if (props.data.formControlKey === "proposerAlternateMobCountryCode"){
      setSectionState(prev => {
        return {
          ...prev,
          sectionData : {
            ...prev.sectionData,
            "AlternateMobNumber" : "",
            "AlternateMobNumbermask" : ""
          }
        }
      })
    }
    // console.log(sectionState, "section state")
  }

  const autoFill = (target) => {
    if (props.data.formControlKey.toLowerCase() === "prcountry") {
      if (props.sectionId === "residenceDetailsSection") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        let fillProposalPageId
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        let tempComponentGroupIndexToChangeForState
        if (props.journeyIdFromStrapi === "ISelect360Journey") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
          fillProposalPageId = "pageISelect360FillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        }

        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRPincode")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "PRState")

        //To Change pincode validation in fill proposal form
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "permanentResidentialDetails")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "PRPincode")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")

        if (sectionState.sectionData[props.data.formControlKey] !== "IN") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "NR",
              }
            })
          })

          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 3
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"

          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRPincode"]: "",
                ["PRState"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          console.log(temp, "dfg")

          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 6
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = null
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagNumber"
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }else if (props.sectionId==="proposerCommonResidenceAndOccupation" && props.data.formControlKey.toLowerCase() === "proposercountry"){
      if (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN") {
        let temp = journeyState.journeySteps
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["proposerState"]: "NR",
            }
          })
        })
      }
    } 
    else   if(sectionState.sectionId==="SectionFlexiEdgeFillProposalCommunicationAddress" && props.data.formControlKey === "permanentAddressProof"){
      if( conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.addressProof"] === sectionState.sectionData["permanentAddressProof"]){
        errorToastr("Current Address and Permanent Address proof cannot be same")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Current Address and Permanent Address proof cannot be same"
          })
        })
        return
      }
      else if(conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.addressProof"]=== "21" && sectionState.sectionData["permanentAddressProof"]=== "17"){
        errorToastr("Current Address and Permanent Address proof cannot be same")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Current Address and Permanent Address proof cannot be same"
          })
        })
        return
      }
      else if(sectionState.sectionData["permanentAddressProof"]=== "21" && conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.addressProof"]=== "17"){
        errorToastr("Current Address and Permanent Address proof cannot be same")
        setErrorState( prev => {
          return ({
          ...prev,
          [props.data.formControlKey]: "Current Address and Permanent Address proof cannot be same"
          })
        })
      }
      else{
        setErrorState( prev => {
          return ({
          ...prev,
          ["permanentAddressProof"]: ""
          })
        })
        return
      }
  }
  else  if(sectionState.sectionId==="SectionFlexiEdgeFillProposalProposerDetails" && props.data.formControlKey === "permanentAddressProof"){
    if(sectionState.sectionData["currentAddressProof"] === sectionState.sectionData["permanentAddressProof"]){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else if(sectionState.sectionData["currentAddressProof"]=== "21" && sectionState.sectionData["permanentAddressProof"]=== "17"){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else if(sectionState.sectionData["permanentAddressProof"]=== "21" && sectionState.sectionData["currentAddressProof"]=== "17"){
      errorToastr("Current Address and Permanent Address proof cannot be same")
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: "Current Address and Permanent Address proof cannot be same"
        })
      })
    }
    else{
      setErrorState( prev => {
        return ({
        ...prev,
        ["permanentAddressProof"]: ""
        })
      })
    }
}
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "CFSectionTitaniumPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["currentCountryofResidence"]: getValueFromLookup("countryCodeToCountry", conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.currentCountryofResidence`]: getValueFromLookup("countryCodeToCountry", conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionInvest4GPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGuaranteedSavingsPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGOPAPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileSelectNumber" && props.sectionId === "sectionGOPAJointLifeQuestionnaire") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeCommunicationCountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageFlexiEdgeFillProposalForm.sectionGOPAJointLifeQuestionnaire.mobileSelectNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.jointlifeCommunicationCountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageFlexiEdgeFillProposalForm.sectionGOPAJointLifeQuestionnaire.mobileSelectNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionJeevanNiveshCalculatePremiumPersonalDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGuaranteedIncomeAdvantagePersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionMoneyBackPersonalDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionInsureSmartPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionSmartJuniorPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionSecureBhavishyaPersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGuaranteedFortunePersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGuaranteedIncome4LifePersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "GAINpersonalDetailsSection") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey === "mobileNumber" && props.sectionId === "SectionGuaranteedFuturePersonelDetails") {
      if (sectionState.sectionData[props.data.formControlKey]) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAcountry"]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"])
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAcountry`]: getValueFromLookup("countryCodeToCountry", conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"]),
          }
        })
      }
    }
    else if (props.data.formControlKey.toLowerCase().includes("country")) {
      if (props.sectionId === "CPResidentAndOccupationDetailSection" ||
        props.sectionId === "iSelect360CPResidentAndOccupationDetailSection") {

        //Temp Indexes will be used either in if or else
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        let fillProposalPageId
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        let tempComponentGroupIndexToChangeForState
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
          fillProposalPageId = "fillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPResidentAndOccupationDetail")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPResidentAndOccupationDetail")
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
          fillProposalPageId = "pageISelect360FillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPResidentAndOccupationDetail")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPResidentAndOccupationDetail")
        } else if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
          fillProposalPageId = "PageFlexiEdgeFillProposalForm"
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "OPdetails")
          tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "OPdetails")
        }

        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "state")

        //To Change pincode validation in fill proposal form
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pinCode")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "pincode")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")

        if (sectionState.sectionData[props.data.formControlKey] !== "IN") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"

          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 3
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"

          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          console.log(temp, "dfg")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"

          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false

          //ValidationsFor fill proposal form
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 6
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = null
          temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagNumber"
          console.log(temp, "iimp")
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if (props.sectionId === "SectionPOSCommunicationAddress") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if (props.journeyIdFromStrapi === "GuaranteedSavingJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSCommunicationAddress")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "permanentResidentialDetailsWithLandMark-MD-12-Order")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRPincode")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "PRState")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentIndexToChangeForState,"GSP Communication")

        if (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"] = "state"
          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = true

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"] = "state_RM"
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if (props.sectionId === "SectionPOSOccupationDetails") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if (props.journeyIdFromStrapi === "GuaranteedSavingJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "officePincode-MD-4-Order-11")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "pincode")
        let tempComponentGroupIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "officeState-MD-4-Order-12")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components.findIndex(element => element.formControlKey === "state")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentGroupIndexToChangeForState, tempComponentIndexToChangeForState, "GSP Occupation")

        if (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"

          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = true
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["lookupKey"] = "state"

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["state"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeForState].components[tempComponentIndexToChangeForState]["lookupKey"] = "state_RM"
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      else if (props.sectionId === "SectionPOSProposerDetails") {

        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if (props.journeyIdFromStrapi === "GuaranteedSavingJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "employerLocation")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "employerPincode")
        let tempComponentIndexToChangeForState = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "employerState")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, tempComponentIndexToChangeForState,"GSP Communication")

        if (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey] !== "IN") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["employerState"]: "NR",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 3
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["max_length"] = 9
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagTextString"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"] = "state"
          //Freezing State key
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = true

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["PRState"]: "",
              }
            })
          })

          let temp = journeyState.journeySteps
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_len"] = 6
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["regex"] = null
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["__typename"] = "ComponentCmpTagNumber"
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["disabled"] = false
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeForState]["lookupKey"] = "state_RM"
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if (props.data.formControlKey.toLowerCase().includes("cpresidentandoccupationtype")) {
      if (props.sectionId === "CPResidentAndOccupationDetailSection" || props.sectionId === "iSelect360CPResidentAndOccupationDetailSection") {

        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        let tempSectionIndexToChange
        let tempComponentGroupIndexToChange
        if (props.journeyIdFromStrapi === "iSelectJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "CPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CPResidentAndOccupationDetail")
        } else if (props.journeyIdFromStrapi === "ISelect360Journey") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
          tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPResidentAndOccupationDetailSection")
          tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPResidentAndOccupationDetail")
        }

        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "CPResidentAndOccupationNatureIndustries")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "temp data")
        // console.log(sectionState.sectionData[props.data.formControlKey], "gfg")
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          // console.log("salaried")
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "611",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        } else if (sectionState.sectionData[props.data.formControlKey] === "4") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "77",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else if (sectionState.sectionData[props.data.formControlKey] === "6") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "664",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })

        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["CPResidentAndOccupationNatureIndustries"]: "",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          console.log(temp, "iimp")

          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if (props.data.formControlKey === "occupation" && props.sectionId == "spouseQuestionnaire") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (props.journeyIdFromStrapi === "ISelect360Journey") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
      }
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "natureOfOccupation-order-10")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "Exactnatureoccupation")
      //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["Exactnatureoccupation"]: "611",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["Exactnatureoccupation"]: "77",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["Exactnatureoccupation"]: "664",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["Exactnatureoccupation"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "occupation" && props.sectionId == "SectionFlexiEdgeFillproposalOccupationDetails") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (ProductJourneyId.includes(props.journeyIdFromStrapi)) {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      }
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "OPdetails")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfDuties")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfDuties"]: "611",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfDuties"]: "77",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfDuties"]: "717",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfDuties"]: "664",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfDuties"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "youAre" && props.sectionId == "SectionFlexiEdgeResidenceandOccupationDetails") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeCalculatePremium")
      }
      
       let lookupForExactNatureofDuties= "natureOfOccupation"
       let lookupforNatureofIndustry= "natureOfIndustry"
      if(sectionState.sectionData[props.data.formControlKey] === "5"){
        lookupForExactNatureofDuties = "natureOfDutieslookupforStudent"
        lookupforNatureofIndustry = "natureOfIndustryLookupForStudent"
      }else if(sectionState.sectionData[props.data.formControlKey] === "9"){
        lookupForExactNatureofDuties = "natureOfDutieslookupforUnemployed"
      }

      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeResidenceandOccupationDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FlexiexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfOccupation")
      let tempComponentGroupIndexToChangeNatureOfIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FlexinatureOfIndustry")
      let tempComponentIndexToChangeNatureOFIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components.findIndex(element => element.formControlKey === "natureOfIndustry")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "611",
              ["natureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B" && getAge(conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.dateOfBirth"]) < 18) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "717",
              ["natureOfIndustry"]: ""
            }
          })
        })

        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "77",
              ["natureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "664",
              ["natureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "9") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "",
              ["natureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforUnemployed"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "5") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "",
              ["natureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforStudent"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustryLookupForStudent" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "",
              ["natureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "occupation" && props.sectionId == "SectionFlexiEdgeFillProposalProposerDetails") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (ProductJourneyId.includes(props.journeyIdFromStrapi)) {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      }
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerOccupationDetails")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfOccupation")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "611",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "77",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "664",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["exactNatureOfOccupation"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "GOPAyouAre" && (props.sectionId == "SectionGuaranteedSavingsPersonelDetails" || props.sectionId == "SectionGOPAPersonelDetails" || props.sectionId == "SectionCommonResidenceAndOccupation" || props.sectionId == "SectionInsureSmartPersonelDetails" || props.sectionId == "SectionMoneyBackPersonalDetails" || props.sectionId == "SectionInvest4GPersonelDetails" || props.sectionId == "SectionJeevanNiveshCalculatePremiumPersonalDetails" || props.sectionId == "SectionSmartJuniorPersonelDetails" || props.sectionId == "SectionSecureBhavishyaPersonelDetails" ||  props.sectionId == "SectionGuaranteedFuturePersonelDetails" || props.sectionId == "proposerCommonResidenceAndOccupation")) {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let pageIdToChange
      let sectionIdToChange
      if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
        pageIdToChange = "PageGuaranteedSavingsCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        pageIdToChange = "PageGuaranteedOnePayCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        pageIdToChange = "PageGuaranteedIncomeAdvantageCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "insureSmart") {
        pageIdToChange = "PageInsureSmartCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
        pageIdToChange = "PageJeevenNiveshCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
        pageIdToChange = "PageMoneyBackCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "invest4GJourney") {
        pageIdToChange = "PageInvest4GCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        pageIdToChange = "PageTitaniumPlusCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        pageIdToChange = "AlphaWealthPlanCalculateFundValuePage"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
        pageIdToChange = "PageSmartJuniorCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
        pageIdToChange = "PageSecureBhavishyaCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        pageIdToChange = "PageGuaranteedFortuneCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
        pageIdToChange = "PageGuaranteedFutureCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        pageIdToChange = "PageGuaranteedIncome4LifeCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "GAINjourney") {
        pageIdToChange = "GAINcalculatePremiumPage"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
        pageIdToChange = "Promise4GrowthPlusCalculateFundValuePage"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } else if (props.journeyIdFromStrapi === "promise4WealthJourney") {
        pageIdToChange = "Pagepromise4WealthJourneyCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
      } 


      let lookupForExactNatureofDuties= "natureOfOccupation"
      let lookupforNatureofIndustry= "natureOfIndustry"
     if(sectionState.sectionData[props.data.formControlKey] === "5"){
       lookupForExactNatureofDuties = "natureOfDutieslookupforStudent"
       lookupforNatureofIndustry = "natureOfIndustryLookupForStudent"
     }else if(sectionState.sectionData[props.data.formControlKey] === "9"){
       lookupForExactNatureofDuties = "natureOfDutieslookupforUnemployed"
     }

      tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAexactNatureOfOccupation")
      let tempComponentGroupIndexToChangeNatureOfIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAnatureOfIndustry")
      let tempComponentIndexToChangeNatureOFIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components.findIndex(element => element.formControlKey === "GOPAnatureOfIndustry")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "611",
              ["GOPAnatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B" &&
        (getAge(conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.dateOfBirth"]) < 18 ||
          getAge(conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAdob"]) < 18 ||
          getAge(conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAdob"]) < 18 ||
          getAge(conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAdob"]) < 18)) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "717",
              ["GOPAnatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "77",
              ["GOPAnatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "664",
              ["GOPAnatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "9") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "",
              ["GOPAnatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforUnemployed"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "5") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "",
              ["GOPAnatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforStudent"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustryLookupForStudent" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "",
              ["GOPAnatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
     else if (props.data.formControlKey === "ProposerYouAre" && props.sectionId == "proposerCommonResidenceAndOccupation"){
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      let pageIdToChange
      let sectionIdToChange
      if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
        pageIdToChange = "PageGuaranteedSavingsCalculatePremium"
      } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        pageIdToChange = "PageGuaranteedOnePayCalculatePremium"
      } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        pageIdToChange = "PageGuaranteedIncomeAdvantageCalculatePremium"
      } else if (props.journeyIdFromStrapi === "insureSmart") {
        pageIdToChange = "PageInsureSmartCalculateFundValue"
      } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
        pageIdToChange = "PageJeevenNiveshCalculatePremium"
      } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
        pageIdToChange = "PageMoneyBackCalculatePremium"
      } else if (props.journeyIdFromStrapi === "invest4GJourney") {
        pageIdToChange = "PageInvest4GCalculateFundValue"
      } else if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        pageIdToChange = "PageTitaniumPlusCalculateFundValue"
      } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        pageIdToChange = "AlphaWealthPlanCalculateFundValuePage"
      } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
        pageIdToChange = "PageSmartJuniorCalculatePremium"
      } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
        pageIdToChange = "PageSecureBhavishyaCalculatePremium"
      } else if (props.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        pageIdToChange = "PageGuaranteedFortuneCalculatePremium"
      } else if (props.journeyIdFromStrapi === "guaranteedFutureJourney") {
        pageIdToChange = "PageGuaranteedFutureCalculatePremium"
      } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        pageIdToChange = "PageGuaranteedIncome4LifeCalculatePremium"
      }  else if (props.journeyIdFromStrapi === "FlexiEdgeJourney") {
        pageIdToChange = "PageFlexiEdgeCalculatePremium"
      } else if (props.journeyIdFromStrapi === "GAINjourney") {
        pageIdToChange = "GAINcalculatePremiumPage"
      } else if (props.journeyIdFromStrapi === "Promise4GrowthPlusJourney") {
        pageIdToChange = "Promise4GrowthPlusCalculateFundValuePage"
      } else if (props.journeyIdFromStrapi === "promise4WealthJourney") {
        pageIdToChange = "Pagepromise4WealthJourneyCalculatePremium"
      }   

      let lookupForExactNatureofDuties= "natureOfOccupation"
      let lookupforNatureofIndustry= "natureOfIndustry"
     if(sectionState.sectionData[props.data.formControlKey] === "5"){
       lookupForExactNatureofDuties = "natureOfDutieslookupforStudent"
       lookupforNatureofIndustry = "natureOfIndustryLookupForStudent"
     }else if(sectionState.sectionData[props.data.formControlKey] === "9"){
       lookupForExactNatureofDuties = "natureOfDutieslookupforUnemployed"
     }
      tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === props.sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerExactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "ProposerExactNatureOfOccupation")
      let tempComponentGroupIndexToChangeNatureOfIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "ProposerNatureOfIndustry")
      let tempComponentIndexToChangeNatureOFIndustry = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components.findIndex(element => element.formControlKey === "ProposerNatureOfIndustry")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "611",
              ["ProposerNatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B" && 
      (getAge(conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.GOPAdob"]) < 18 || 
      getAge(conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.dateOfBirth"]) < 18 ||
      getAge(conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.GOPAdob"]) < 18 ||
      getAge(conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.GOPAproposerDateOfBirth"]) < 18 ||
      getAge(conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.GOPAdob"]) < 18 )) {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "717",
              ["ProposerNatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "77",
              ["ProposerNatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "664",
              ["ProposerNatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "9") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "",
              ["ProposerNatureOfIndustry"]: "05"
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforUnemployed"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "5") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "",
              ["ProposerNatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfDutieslookupforStudent"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustryLookupForStudent" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["ProposerExactNatureOfOccupation"]: "",
              ["ProposerNatureOfIndustry"]: ""
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChangeNatureOfIndustry].components[tempComponentIndexToChangeNatureOFIndustry]["lookupKey"] = "natureOfIndustry" 
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "GOPAyouAre" && props.sectionId == "SectionInsureSmartPersonelDetails") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (props.journeyIdFromStrapi === "insureSmart") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageInsureSmartCalculateFundValue")
      }
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionInsureSmartPersonelDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAexactNatureOfOccupation")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "611",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "717",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "77",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "664",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAexactNatureOfOccupation"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    else if (props.data.formControlKey === "AppointeeFullNameTitle" && journeyState.journeyIdFromStrapi !== "GuaranteedSavingJourney") {
      let fillProposalPageId
      if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
        fillProposalPageId = "fillProposalForm"
      } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
        fillProposalPageId = "pageISelect360FillProposalForm"
      }
      let gender
      let lookup
      if (sectionState.sectionData["AppointeeFullNameTitle"] === "MR") {
        gender = "M"
        lookup = "appointeeRelationshipWithNomineeMale"
      } else if (sectionState.sectionData?.["AppointeeFullNameTitle"] === "MS" || sectionState.sectionData?.["AppointeeFullNameTitle"] === "MRS") {
        gender = "F"
        lookup = "appointeeRelationshipWithNomineeFemale"
      }
      if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
        gender = "T"
        lookup = "appointeeRelationshipWithNominee"
      }
      let temp = journeyState.journeySteps
      let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId) // validate dynamic pageid
      let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "AppointeeDetailSection")
      let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender")
      let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")

      let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "AppointeeRelationshipWithUser")
      let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "AppointeeRelationWithUser")
      console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
      // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
      temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            ["gender"]: gender,
          },
        }
      })
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.gender`]: gender,
        }
      })
      if (errorState["gender"]) {
        setErrorState(prev => {
          return ({
            ...prev,
            ["gender"]: ""
          })
        })
        // if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index]){
        //   if(sectionState.sectionData["gender"][props.index] === "M" && sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR")
        // }
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
    else if (journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSNomineeDetails") {
      if (props.data.formControlKey === "fullNameTitle") {
        let gender
        let lookup
        if (sectionState.sectionData["fullNameTitle"] === "MR") {
          gender = "M"
          lookup = "nomineeRelationshipWithLAMale"
        } else if (sectionState.sectionData?.["fullNameTitle"] === "MS" || sectionState.sectionData?.["fullNameTitle"] === "MRS") {
          gender = "F"
          lookup = "nomineeRelationshipWithLAFemale"
        }
        if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
          gender = "T"
          lookup = "nomineeRelationshipWithLA"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSNomineeDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")

        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeRelationshipWithUser")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "nomineeRelationshipWithUser")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.gender`]: gender,
          }
        })
        if (errorState["gender"]) {
          setErrorState(prev => {
            return ({
              ...prev,
              ["gender"]: ""
            })
          })
        }
      }
      else if (props.data.formControlKey === "AppointeeFullNameTitle") {
        let gender
        let lookup
        if (sectionState.sectionData["AppointeeFullNameTitle"] === "MR") {
          gender = "M"
          lookup = "appointeeRelationshipWithNomineeMale"
        } else if (sectionState.sectionData?.["AppointeeFullNameTitle"] === "MS" || sectionState.sectionData?.["AppointeeFullNameTitle"] === "MRS") {
          gender = "F"
          lookup = "appointeeRelationshipWithNomineeFemale"
        }
        if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
          gender = "T"
          lookup = "appointeeRelationshipWithNominee"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSNomineeDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "appointeeDetailsOverall-MD-12-Order-7")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "appointeeGender")

        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "appointeeRelationshipWithLA-MD-6-Order-8")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "AppointeeRelationWithUser")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["appointeeGender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.appointeeGender`]: gender,
          }
        })
        if (errorState["gender"]) {
          setErrorState(prev => {
            return ({
              ...prev,
              ["appointeeGender"]: ""
            })
          })
        }
      }
    }
    else if ((ProductJourneyId.includes(props.journeyIdFromStrapi)) && (props.sectionId == "SectionFlexiEdgeFillProposalNomineeDetails" || props.sectionId === "FlexiEdgeFillProposalAppointeeSection")) {
      if (props.data.formControlKey === "nomineeTitle") {
        let gender
        let lookup
        if (sectionState.sectionData["nomineeTitle"] === "MR") {
          gender = "M"
          lookup = "nomineeRelationshipWithLAMale"
        } else if (sectionState.sectionData?.["nomineeTitle"] === "MS" || sectionState.sectionData?.["nomineeTitle"] === "MRS") {
          gender = "F"
          lookup = "nomineeRelationshipWithLAFemale"
        }
        if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
          gender = "T"
          lookup = "nomineeRelationshipWithLA"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeGender")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "nomineeGender")

        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeRelationshipWithUser")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "nomineeRelationshipWithUser")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["nomineeGender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.nomineeGender`]: gender,
          }
        })
        if (errorState["nomineeGender"]) {
          setErrorState(prev => {
            return ({
              ...prev,
              ["nomineeGender"]: ""
            })
          })
        }
      }
      else if (props.data.formControlKey === "titleNominee") {
        let gender
        let lookup
        if (sectionState.sectionData["titleNominee"] === "MR") {
          gender = "M"
          lookup = "appointeeRelationshipWithNomineeMale"
        } else if (sectionState.sectionData?.["titleNominee"] === "MS" || sectionState.sectionData?.["titleNominee"] === "MRS") {
          gender = "F"
          lookup = "appointeeRelationshipWithNomineeFemale"
        }
        if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
          gender = "T"
          lookup = "appointeeRelationshipWithNominee"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "FlexiEdgeFillProposalAppointeeSection")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "AppointeeGender")

        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "nomineeRelationship")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["AppointeeGender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.AppointeeGender`]: gender,
          }
        })
        if (errorState["AppointeeGender"]) {
          setErrorState(prev => {
            return ({
              ...prev,
              ["AppointeeGender"]: ""
            })
          })
        }
      }
    }
    else if (journeyState.journeyIdFromStrapi == "GuaranteedSavingJourney" && props.sectionId == "SectionPOSProposerDetails") {
      if (props.data.formControlKey === "fullNameTitle") {
        let gender
        let lookup
        if (sectionState.sectionData["fullNameTitle"] === "MR") {
          gender = "M"
          lookup = "proposerRelationshipWithLAMale"
        } else if (sectionState.sectionData?.["fullNameTitle"] === "MS" || sectionState.sectionData?.["fullNameTitle"] === "MRS") {
          gender = "F"
          lookup = "proposerRelationshipWithLAFemale"
        }
        if (sectionState.sectionData["gender"] && sectionState.sectionData["gender"] === "T") {
          gender = "T"
          lookup = "proposerRelationshipWithLA"
        }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "SectionPOSProposerDetails")
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "gender-proposer-MD-6-Order-4(with margin fix class)")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "gender")

        let tempComponentGroupIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "proposerRelationshipWithLA")
        let tempComponentIdRelation = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components.findIndex(element => element.formControlKey === "proposerRelationshipWithLife")
        console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1")
        // temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["disabled"] = true
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupIdRelation].components[tempComponentIdRelation]["lookupKey"] = lookup
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: gender,
            },
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.gender`]: gender,
          }
        })
        if (errorState["gender"]) {
          setErrorState(prev => {
            return ({
              ...prev,
              ["gender"]: ""
            })
          })
        }
      }
    }
    else if (props.data.formControlKey === "InsureSmartOccupation" || props.data.formControlKey === "occupation") {
      if (props.sectionId === "SectionGuaranteedSavingPersonaldetails") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if (props.journeyIdFromStrapi === "GuaranteedSavingJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedSavingCalculatePremium")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedSavingPersonaldetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "natureOfOccupation/duties-MD-6-order-13.1")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "InsureSmartExactOccupation")
        //console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["InsureSmartExactOccupation"]: "611",
              }
            })
          })
          // Hide a disable dropodown
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["InsureSmartExactOccupation"]: "",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
      if (props.sectionId === "SectionPOSOccupationDetails") {
        let temp = journeyState.journeySteps
        let tempPageIndexToChange
        if (props.journeyIdFromStrapi === "GuaranteedSavingJourney") {
          tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PagePOSFillProposalForm")
        }
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionPOSOccupationDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "exactNatureOfOccupation-MD-6-Order-1")
        let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfOccupation")
        console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "FOR GSP")
        if (sectionState.sectionData[props.data.formControlKey] === "1") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["exactNatureOfOccupation"]: "611",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        } else {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["exactNatureOfOccupation"]: "",
              }
            })
          })
          //temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
      }
    }
    else if (props.data.formControlKey === "jointlifeOccupation" && props.sectionId == "sectionGOPAJointLifeQuestionnaire") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange
      if (props.journeyIdFromStrapi === "GuarateedOnePayJourney" || props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      }
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "sectionGOPAJointLifeQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "jointlifeExactnatureofduties/occupationOrder-24")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "jointlifeExactnatureofduties_occupation")
      if (sectionState.sectionData[props.data.formControlKey] === "1") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeExactnatureofduties_occupation"]: "611",
            }
          })
        })
        console.log("qwertyytrew", sectionState);
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "B") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeExactnatureofduties_occupation"]: "717",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "4") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeExactnatureofduties_occupation"]: "77",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else if (sectionState.sectionData[props.data.formControlKey] === "6") {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeExactnatureofduties_occupation"]: "664",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["jointlifeExactnatureofduties_occupation"]: "",
            }
          })
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
    // auto fill validation on country for pincodes
    pincodeGenricValidation()
  }
  useEffect(() => {
    pincodeGenricValidation()
  }, [sectionState.sectionData?.['proposerCountry'], sectionState.sectionData?.['countryofbirth'], sectionState.sectionData?.['appointeeCountry'], sectionState.sectionData?.['currentCountryofResidence'], sectionState.sectionData?.['country'], sectionState.sectionData?.['GOPAcountry'], sectionState.sectionData?.['jointlifeCommunicationCountry'],sectionState.sectionData?.['permanentCountry']])

  useEffect(() => {
    if ((props.sectionId == "SectionFlexiEdgeResidenceandOccupationDetails" || props.sectionId === "SectionCommonResidenceAndOccupation") && (props.data.formControlKey =="youAre" || props.data.formControlKey =="GOPAyouAre")) {
        let lookup
        let lookupExactNature
        if((conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".gender"]=== "M") || ((conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".GOPAgender"] === "M"))){
          lookup = "occupationForMale"
          lookupExactNature = "natureOfOccupationForMale"
        }else{
          lookup = "occupation"
          lookupExactNature = "natureOfOccupation"
        }
        let compGroupOccupation
        let compOccupation
        let compGroupOccupationList
        let compOccupationList
        if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){
          compGroupOccupation = "FlexiyouAre"
          compOccupation = "youAre"
          compGroupOccupationList = "FlexiexactNatureOfOccupation"
          compOccupationList = "exactNatureOfOccupation"
        }else{
          compGroupOccupation = "GOPAyouAre"
          compOccupation = "GOPAyouAre"
          compGroupOccupationList = "GOPAexactNatureOfOccupation"
          compOccupationList = "GOPAexactNatureOfOccupation"
        }
        let temp = journeyState.journeySteps
        let tempPage = temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSection = temp.pages[tempPage].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupOccupation = temp.pages[tempPage].sections[tempSection].component_groups.findIndex(element => element.componentId ===compGroupOccupation)
        let tempComponentOccupation = temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupation].components.findIndex(element => element.formControlKey === compOccupation)
        let tempComponentGroupOccupationList = temp.pages[tempPage].sections[tempSection].component_groups.findIndex(element =>element.componentId === compGroupOccupationList)
        let tempComponentOccupationList = temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components.findIndex(element => element.formControlKey === compOccupationList)
        temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupation].components[tempComponentOccupation]["lookupKey"] = lookup
        temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components[tempComponentOccupationList]["lookupKey"] = lookupExactNature
        if (sectionState.sectionData[props.data.formControlKey] === "4" && (conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".gender"]=== "M" || conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".GOPAgender"] === "M")) {
          temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components[tempComponentOccupationList]["disabled"] = false
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                [compOccupation]: "",
                [compOccupationList] : ""
              }
            })
          })
        }
    }
    if (props.sectionId == "proposerCommonResidenceAndOccupation" && props.data.formControlKey =="ProposerYouAre" ) {
      let lookup
      let lookupExactNature
      if((conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".proposergender"]=== "M") || ((conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".GOPAproposerGender"] === "M"))){
        lookup = "occupationForMale"
        lookupExactNature = "natureOfOccupationForMale"
      }else{
        lookup = "occupation"
        lookupExactNature = "natureOfOccupation"
      }
        let temp = journeyState.journeySteps
        let tempPage= temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSection = temp.pages[tempPage].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupOccupation = temp.pages[tempPage].sections[tempSection].component_groups.findIndex(element => element.componentId === "ProposerYouAre" )
        let tempComponentOccupation = temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupation].components.findIndex(element => element.formControlKey === "ProposerYouAre")
        let tempComponentGroupOccupationList = temp.pages[tempPage].sections[tempSection].component_groups.findIndex(element => element.componentId === "ProposerExactNatureOfOccupation")
        let tempComponentOccupationList = temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components.findIndex(element => element.formControlKey === "ProposerExactNatureOfOccupation" )
        temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components[tempComponentOccupationList]["lookupKey"] = lookupExactNature
        temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupation].components[tempComponentOccupation]["lookupKey"] = lookup
        if (sectionState.sectionData[props.data.formControlKey] === "4" && (conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".proposergender"]=== "M" || conditionState[generateConditonStateString(journeyState.journeyIdFromStrapi)+".GOPAproposerGender"] === "M")) {
          temp.pages[tempPage].sections[tempSection].component_groups[tempComponentGroupOccupationList].components[tempComponentOccupationList]["disabled"] = false
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["ProposerYouAre"]: "",
                ["ProposerExactNatureOfOccupation"]: "",
              }
            })
          })
        }
    }
  },[])

  useEffect(() => {
    if ((props.sectionId == "sectionGOPAJointLifeQuestionnaire") && (props.data.formControlKey =="jointlifeOccupation" || props.data.formControlKey =="jointlifeExactnatureofduties_occupation") ) {
      let lookup
      console.log("JourneyState:",journeyState)
      console.log(generateConditonStateString(journeyState.journeyIdFromStrapi.toLowerCase()))
     if(props.data.formControlKey =="jointlifeOccupation"){
      if((conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "M")){
        console.log(conditionState)
        lookup = "occupationForMale"
      }else if((conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "F") || (conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "T")){
        lookup = "occupation"
      }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "jointlifeOccupationOrder-23")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "jointlifeOccupation")
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["lookupKey"] = lookup
     }else if(props.data.formControlKey =="jointlifeExactnatureofduties_occupation"){
      if((conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "M")){
        lookup = "natureOfOccupationForMale"
      }else if((conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "F") || (conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAChooseYourPlan.GOPAcpgender"]=== "T")){
        lookup = "natureOfOccupation"
      }
        let temp = journeyState.journeySteps
        let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === props.pageId)
        let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === props.sectionId)
        let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "jointlifeExactnatureofduties/occupationOrder-24" || element.componentId === "GOPAexactNatureOfOccupation")
        let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "jointlifeExactnatureofduties_occupation" || element.formControlKey === "exactNatureOfOccupation" )
        temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["lookupKey"] = lookup
     }

    }
  },[])

  useEffect(() => {
    if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney" && props.data.formControlKey === "relationshipLifeAssured" && props.sectionId === "sectionGOPAJointLifeQuestionnaire"){
      let martialStatus = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.martialStatus"]
      let relationshipLookup;
      if (martialStatus === "M"){
        relationshipLookup = "jointLifeWithLAMale"
      }else{
        relationshipLookup = "jointLifeWithLAMaleUnmarried"
      }
      let temp = journeyState.journeySteps // direct change in state, wrorks in isnp this way
      let tempPageIndexToChange = temp.pages?.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages?.[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "sectionGOPAJointLifeQuestionnaire")
      let tempComponentGroupIndexToChange = temp.pages?.[tempPageIndexToChange]?.sections?.[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp?.componentId === "jointlifeRelationshipLifeAssuredOrder-5")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[0].lookupKey = relationshipLookup
      
      setTimeout(() => {
        if (sectionState.sectionData["relationshipLifeAssured"] && !Object.keys(lookup[relationshipLookup][0]).includes(sectionState.sectionData["relationshipLifeAssured"])){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["relationshipLifeAssured"]: "",
              }
            }
          })
        }
      },1600)
    }
  },[props?.sectionId])
  

  // const getSelectedValue = () => {
  //   let key = Object.keys(props.options).filter(function(key) {return props.options[key] === sectionState.sectionData[props.data.formControlKey] })[0];
  //   console.log(key,"dhbe")
  //   return key
  // }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }
  let options = props.options
  options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: val,
  }))
  if (props?.data?.formControlKey === "fundValue" && props?.sectionId === "AlphaWealthPlanPortfolioManangementSection"){
    options.sort((a, b) => parseFloat(a.label) - parseFloat(b.label));
  }
  if (props?.data?.formControlKey === "ageIdentityProof" || props?.data?.formControlKey === "idProof"){
    const topElements = [];
    const endElements = [];
    
    options.forEach(option => {
      if (lookup.NSAP_AGE_PROOF[0].hasOwnProperty(option.value)) { // push age proof which are nsap at the end
        endElements.push(option);
      } else {
        topElements.push(option);
      }
    });
    options = [...topElements,...endElements]
  }
  return (
    <>
      <SelectContainer channel={props.channel} className={`input-container ${props.data.disabled ? 'disable-input' : ''} ${props.data?.freeze ? 'freeze-input' : ''} ${props.data.html ? "input-auto-height" : ''}`}>
        <label htmlFor={props.data.label} className="input-label">
          {(getValueFromJourney(
            journeyState.lookup.label,
            props.data.label
          )) || props.data.label}
          {props.data.tooltip &&
            <span style={{ marginLeft: "10px" }} className="tooltip-col text-tool-tip-design existing-tool-tip">
              <div className="tool">i</div>
              <span className="tooltiptext4 tooltiptext5 tooltiptext4-align-list " style={{ width: "22rem", height: "fit-content", top: "auto", pointerEvents: "none" }}>
                {Parser((getValueFromJourney(
                  journeyState.lookup.tooltip,
                  props.data.tooltip
                )))}
              </span>
            </span>
          }
        </label>
        <Select
          // className="form-control"
          // styles={customStyles}
          options={options}
          name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelect"
          required={props.data.required}
          onChange={handleChange}
          // className={props.data.disabled?"disable-input":""}
          tabIndex={props.data.disabled || props.data?.freeze ? -1 : 0}
          // value={
          //   sectionState.sectionData[props.data.formControlKey]
          //     ? getKeyByValue(
          //         options,
          //         sectionState.sectionData[props.data.formControlKey]
          //       )
          //     : ""
          // }
          value={
            sectionState.sectionData?.[props.data.formControlKey]
              ? getKeyByValue(
                options,
                sectionState.sectionData[props.data.formControlKey]
              )
              : ""
          }
          onBlur={e => autoFill(e.target)}
        ></Select>
        <span className="input-error2">
          {(props.showError && showLocalError) && errorState[props.data.formControlKey]}
        </span>
        <div dangerouslySetInnerHTML={{ __html: props.data.html }} ></div>
      </SelectContainer>
    </>
  )
}
